import { Modal } from 'react-daisyui';
import { Check, FileText, X } from 'lucide-react';
import { choiceBtnUnselected } from 'components/Profile/helper';

const ConsentModal = ({ consentForm, onClose, onAgree }) => {
  const { title, content, pdf_url } = consentForm?.attributes || {};

  return (
    <Modal
      open
      style={{ margin: 0, backgroundColor: 'rgba(15, 23, 42, 0.45)' }}
      className="flex max-h-[calc(100dvh-1.5rem)] w-[92%] max-w-2xl flex-col overflow-hidden rounded-2xl p-0 shadow-2xl sm:max-h-[calc(100vh-4rem)]"
    >
      <div className="flex flex-shrink-0 items-center gap-3 bg-secondary-900 px-4 py-3.5 sm:gap-4 sm:px-5 sm:py-4">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white/10 text-white sm:h-11 sm:w-11">
          <FileText size={20} strokeWidth={2} />
        </span>

        <div className="min-w-0 flex-1">
          <p className="text-[10px] font-semibold uppercase tracking-[0.14em] text-white/50 sm:text-[11px]">Legal document</p>
          <h3 className="truncate text-base font-bold text-white sm:text-lg">{title}</h3>
        </div>

        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white/10 text-white transition-colors hover:bg-white/20"
        >
          <X size={18} strokeWidth={2.5} />
        </button>
      </div>

      {pdf_url ? (
        <div className="min-h-0 overflow-hidden">
          <iframe
            src={`${pdf_url}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
            title={title}
            className="-m-5 aspect-[1/1.15] w-[calc(100%+2.5rem)] border-0"
          />
        </div>
      ) : (
        <div
          className={`min-h-0 flex-1 overflow-y-auto px-4 py-5 sm:px-6`}
          dangerouslySetInnerHTML={{ __html: content || '' }}
        />
      )}

      <div className="flex flex-shrink-0 items-center justify-between gap-3 border-t border-gray-100 px-4 py-3.5 sm:px-6 sm:py-4">
        {pdf_url ? (
          <p className="flex items-center gap-2 text-[13px] font-semibold text-success-600">
            <Check size={15} strokeWidth={3} /> Signed copy — kept on file
          </p>
        ) : (
          <p className="hidden text-[13px] text-secondary-400 sm:block">Please review the full document before agreeing.</p>
        )}

        <div className="flex items-center gap-3">
          <button type="button" onClick={onClose} className={`btn h-10 min-h-0 rounded-xl font-semibold ${choiceBtnUnselected}`}>
            Close
          </button>

          {!pdf_url && (
            <button
              type="button"
              onClick={onAgree}
              className="btn h-10 min-h-0 gap-2 rounded-xl border-none bg-secondary-900 font-semibold text-white hover:bg-black"
            >
              <Check size={16} strokeWidth={2.8} /> I agree
            </button>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ConsentModal;
